import React from "react"
import SocialMedia from "../SocialMedia"
import { NewsletterContainer, ColoredBar } from "./style"

const NewsLetterForm = () => {
  return (
    <NewsletterContainer>
      <ColoredBar />
      <iframe
        src="https://udaraw.substack.com/embed"
        width="480"
        height="320"
        style={{
          border: "1px solid #EEE",
          background: "white",
          maxWidth: "100%",
          boxSizing: "border-box"
        }}
        frameBorder="0"
        scrolling="no"
        title="Subscribe to newsletter"
      />
      <br />
      <SocialMedia align="center" />
    </NewsletterContainer>
  )
}

export default NewsLetterForm
